export enum SimpleGridCellType {
    string = 0,
    numeric
}